import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Button } from "@gemini/ui";
import { PhoneIcon } from "@gemini/icons";
import { MobilePhonesModal } from "../Modals/MobilePhonesModal";
import { useTrackingLeadInterestPhone } from "@/hooks";
import { useClassifiedAnalytics } from "@/hooks/tracking/classifiedAnalytics";
import { CA_EVENT_TYPES } from "@/types/classifiedAnalytics";
import { useClassified } from "@/contexts/classified";
import { useTrackingLegacyLeadEvents } from "@/hooks/tracking/trackingLegacy";
import { CallTrackingStatus, useCallTracking } from "@/contexts/callTracking";
export const displayPhoneNumbersButtonTestId = "cdp-contacting-display-phone-numbers-button";
export const DisplayPhoneNumbersButton = ({ label, variant, isFullWidth = true, phoneNumbers, tracking, iconOnly = false, }) => {
    var _a;
    const [isOpen, setIsOpen] = useState(false);
    const trackLeadPhoneInterestEvent = useTrackingLeadInterestPhone(tracking.avZone);
    const { sendClassifiedAnalyticsEvent } = useClassifiedAnalytics();
    const legacyTrackingData = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.legacyTracking;
    const { legacyLeadConversionPhone } = useTrackingLegacyLeadEvents(); // Legacy GA3 for harvest
    const { fetchCallTrackingData, status: callTrackingStatus, virtualPhoneNumbers, } = useCallTracking();
    const handleCallTracking = () => {
        if (callTrackingStatus === CallTrackingStatus.IDLE) {
            fetchCallTrackingData();
        }
    };
    const handleLegacyTracking = () => {
        const hasTrackingData = !!legacyTrackingData;
        if (hasTrackingData) {
            legacyLeadConversionPhone({
                eventData: { infos: tracking.legacy },
            });
        }
    };
    const handleTracking = () => {
        trackLeadPhoneInterestEvent();
        sendClassifiedAnalyticsEvent(CA_EVENT_TYPES.PHONE_NUMBER_DISPLAY);
        handleLegacyTracking();
    };
    const handleOnPress = () => {
        handleCallTracking();
        handleTracking();
        if (callTrackingStatus !== CallTrackingStatus.LOADING) {
            setIsOpen(true);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { variant: variant, isFullWidth: isFullWidth, icon: PhoneIcon, onPress: handleOnPress, iconOnly: iconOnly, isLoading: callTrackingStatus === CallTrackingStatus.LOADING, testId: displayPhoneNumbersButtonTestId, children: label }), _jsx(MobilePhonesModal, { onOpenChange: setIsOpen, isOpen: isOpen, phoneNumbers: (virtualPhoneNumbers === null || virtualPhoneNumbers === void 0 ? void 0 : virtualPhoneNumbers.length) ? virtualPhoneNumbers : phoneNumbers })] }));
};
